module.exports = __webpack_public_path__ + "static/media/spotify.cf7f8683.jpg";